
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Bei einer Narkolepsie haben Betroffene das Gefühl, sie hätten drei oder vier Tage hintereinander nicht geschlafen. Laut Schätzungen ist nur einer von 2000 Menschen davon betroffen. Gemäss Matthew Walker, Professor für Neurowissenschaften und Psychologie an der University of California in Berkeley, ist dieses ungeheure Schlafbedürfnis so problematisch, weil das unwiderstehliches Verlangen nach Schlaf zu allen möglichen Zeitpunkten im Alltag auftauchen kann. In medizinischer Hinsicht sei Narkolepsie eine neurologische Störung, was bedeutet, dass ihre Ursachen im zentralen Nervensystem liegen. Die Behandlungsmethoden für Narkoleptiker sind momentan noch dürftig.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;